import { useJanelaDoComite } from '../../api/queries/gmuds'
import { Esqueleto } from '../../components/Estados'
import { dataHoraPorExtenso } from '../../lib/datas'
import { TEXTOS } from '../../lib/glossario'

/**
 * Quando o comitê analisa e a partir de que hora o aprovado pode ir a produção.
 *
 * **Os dias vêm do servidor, e não de um texto na tela.** Eles já mudaram uma vez — o TR registra
 * "atualmente o CAB analisa às 3ª e 4ª feiras", e é a palavra "atualmente" que permite à CONTRATANTE
 * mudar o dia sem aditivo. Hoje é terça e quinta. Quando mudar de novo, muda-se o `.env`; da última
 * vez, foi preciso caçar o texto em cinco arquivos.
 *
 * **A ressalva sobre implantar fora da janela é a parte que importa.** O sistema não bloqueia — é
 * fato contratual, não regra de software —, e uma tela que só mostrasse o horário deixaria o
 * executor concluir que fora dele é impossível, em vez de custoso.
 *
 * @returns o cartão da janela
 */
export function JanelaDeImplantacao() {
  const { data: janela, isPending } = useJanelaDoComite()

  if (isPending) {
    return (
      <div className="cartao px-4 py-4">
        <Esqueleto linhas={2} />
      </div>
    )
  }

  if (!janela) {
    return null
  }

  return (
    <div className="cartao px-4 py-4">
      <div className="flex flex-wrap items-baseline gap-x-6 gap-y-2 text-sm">
        <p className="text-slate-700">
          <span className="text-xs font-medium text-slate-500">
            {TEXTOS.cab.calendario.diasDeAnalise}:{' '}
          </span>
          <span className="font-medium">{janela.diasDeAnalise.join(' e ')}</span>
        </p>
        <p className="text-slate-700">
          <span className="text-xs font-medium text-slate-500">
            {TEXTOS.cab.calendario.janelaDeImplantacao}:{' '}
          </span>
          <span className="font-medium">{janela.aberturaDaImplantacao}</span>
        </p>
        <p className="text-slate-700">
          <span className="text-xs font-medium text-slate-500">{TEXTOS.cab.calendario.proxima}: </span>
          <span className="font-medium">{dataHoraPorExtenso(janela.proximaAbertura)}</span>
        </p>
        <span
          className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${
            janela.abertaAgora ? 'bg-green-100 text-green-900' : 'bg-slate-100 text-slate-700'
          }`}
        >
          {janela.abertaAgora ? TEXTOS.cab.calendario.abertaAgora : TEXTOS.cab.calendario.fechadaAgora}
        </span>
      </div>
    </div>
  )
}
